import { Handle } from "@xyflow/react";
import RightArrow from "../../../../assets/arrow-right.svg";
import React from "react";
import { IconButton } from "@mui/material";
import CloseIcon from "../../../../assets/closeIcon.svg";
import Dialer from "../../../../assets/dialer.svg";
import { NodeActions } from "../ivr";

export default function IvrMenuNode({data, selected, id}) {
  const keypressActionsLength = data.keypressActions.filter(kp => kp.isRendered).length;
	return (
		<div style={{ position: "relative" }}>
        <div style={{
			display: "inline-block",
			borderRadius: 8,
			padding: selected ? 4 : 0,
      boxShadow: (data.showInvalid && data.invalid) ? "0 0 0 0 #fff" : selected ? "0px 0px 3.01px 3.01px #34CB65, 0px 0px 0px 1.5px #FFFFFF" : "0 0 0 0 #fff",
      border: (data.showInvalid && data.invalid) ? "1.5px solid #F44336" : "none",
			transition: "box-shadow 0.3s, padding 0.3s, border 0.3s",
			backgroundColor: "transparent"
		}}>
          <div style={{ ...localStyles.container, fontFamily: "'Roboto', sans-serif", overflow: "hidden", display: "flex", flexDirection: "column", margin: 4, padding: 0 }}>
            <div style={{ backgroundColor: "#5ACCFF", height: "6px", borderTopLeftRadius: "8px", borderTopRightRadius: "8px", margin: "0" }} />
            <div style={{ display: "flex", alignItems: "center", padding: "12px 16px", gap: 8, borderBottom: "1px solid #E0E0E0" }}>
              <div style={{ width: 28, height: 28, borderRadius: "50%", backgroundColor: "#E5F6EE", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <img src={Dialer} alt="Dialer" style={localStyles.img} />
              </div>
              <div className="t7 nc-gray-900 medium-font" style={{textDecoration: selected ? "underline" : "none"}}>{data.name}</div>
            </div>
            <div style={{ padding: "12px 16px", flexGrow: 1, overflowY: 'auto', maxHeight: 130}}>
              {Array.isArray(data.keypressActions) && data.keypressActions.map(({ digit, action, selectedUser, selectedTeam, selectedName, isRendered}) => {
                if(!isRendered) return null;
                let display = action ?? "";
                // console.log("display, action, digit", display, action, digit);
                if([NodeActions.toTeam, NodeActions.toUser].includes(action) && selectedName) {
					        display = selectedName;
                }
                // else if (action === NodeActions.ivr) display = `IVR ${digit}`;
                else display = action;
                return (
                  <div key={`ivr-action-${digit}`} className="t8 nc-gray-900 medium-font" style={{ marginBottom: 4 }}>
                    Press {digit} for
                    <img src={RightArrow} alt="Right Arrow" style={{ margin: "0 4px", width: "12px", height: "12px" }} />
                    {display} 
                    {/* {console.log("digit, action, display", digit, action, display)} */}
                  </div>
                );
              })}
            </div>
            <div style={{ display: "flex", borderTop: "1px solid #E0E0E0", backgroundColor: "#FAFAFA" }}>
              {Array.isArray(data.keypressActions) && data.keypressActions.map(({ digit, isRendered }, i) => (isRendered ?
                <div key={`ivr-handle-${digit}`} style={{ height: "44px", flex: 1, textAlign: "center", padding: "14px 0", borderRight: i !== data.keypressActions.length - 1 ? "1px solid #E0E0E0" : "none", cursor: "pointer" }} > {/*onClick={() => data.onSelectKeypress()}*/}
                  <div className="t8 nc-gray-900 medium-font" style={{position: "relative", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between"}}>
                    <div>
                      {digit}
                    </div>
                    <Handle key={`handle-${id}-${digit}`} type="source" position="bottom" style={{ background: "#fff", position: "absolute", bottom: -16, left: "50%", }} id={`handle-ivr-${digit}`} />
                  </div>
                </div>
              : null))}
            </div>
            <Handle type="target" position="top" style={localStyles.handle} id="target-ivr" />
          </div>
        </div>
        <IconButton disabled={!selected} onClick={data.onDelete} style={{ position: "absolute", top: 25, right: 18, padding: 4,}}>
          <img src={CloseIcon} alt="Close" style={{ width: "14px", height: "14px" }} />
        </IconButton>
      </div>
	)
}

const nodeDimensions = { width: "352px" };
const localStyles = {
	img: {
		width: 16,
		height: 16,
	},
	container: {
		width: nodeDimensions.width,
		border: "1px solid #E0E0E0",
		borderRadius: 8,
		backgroundColor: "#fff"
	},
	handle: {
		background: "#555" },
}